import cookie from 'react-cookie';
import FormatCurrency from './format-currency';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import './currency.scss';

class PriceWrapper extends Component {
  getLabel = (label) => {
    return (label === 'Annual') || (!label) ? '' : `${label}: `;
  };

  render() {
    const currency = this.props.selectedCurrency || cookie.load('aw_currency_pref');
    const isPriceUponRequest = this.props.displayPrice === 'Price Upon Request';
    const usdSuffix = currency &&
      currency.code !== 'USD' &&
      !isPriceUponRequest &&
      typeof this.props.priceInt === 'number' ? (<span>&nbsp;USD</span>) : null;
    const classes = this.props.classes || '';

    return (
      <span className={classes + (usdSuffix ? " multi-currency-display" : "")}>
        <span>{this.getLabel(this.props.label)}</span>
        {this.props.prefix}
        <FormatCurrency
          price={this.props.priceInt}
          isPriceUponRequest={isPriceUponRequest}
          selectedCurrency={currency}/>
        <span className="usd-price">{this.props.displayPrice}{usdSuffix}</span>
        &nbsp;
        {this.props.suffix}
      </span>
    );
  }
}

PriceWrapper.propTypes = {
  classes: PropTypes.string,
  displayPrice: PropTypes.string,
  label: PropTypes.string,
  prefix: PropTypes.string,
  priceInt: PropTypes.number,
  selectedCurrency: PropTypes.object,
  suffix: PropTypes.string
};

export default PriceWrapper;



// WEBPACK FOOTER //
// ./src/components/shared/currency/price-wrapper.js